import * as React from "react";
import EditBrandFormView from "./EditBrandFormView";
import Brand from "../../../../../model/brand/Brand";
import {connect} from "react-redux";
import {OnFailure, OnSuccess} from "../../../../../store/action/actionHelpers";
import {Dispatch} from "redux";
import Toast from "../../../../helper/Toast";
import {updateBrand} from "../../../../../store/action/brand/brand";
import {none, option, Option} from "ts-option";
import Address from "../../../../../model/address/Address";
import {RootState} from "../../../../../store/reducer/root/RootState";
import Site from "../../../../../model/site/Site";
import Loading from "../../../../ui/loading/Loading";
import {fetchSite} from "../../../../../store/action/site/site";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";

interface IComponentProps {
	/**
	 * On successful created brand callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Brand to edit.
	 */
	brand: Brand;
}

interface IDispatchProps {
	/**
	 * Update brand.
	 * @param {brand} brand
	 * @param {Option<File>} brand logo
	 * @param {Option<Address>} address
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateBrand: (brandId: string,
		brand: Brand,
		file: Option<File>,
		address: Option<Address>,
		shouldRemoveLogo: boolean,
		onSuccess: OnSuccess,
		onFailure: OnFailure) => void;
	/**
	 * Fetch Site
	 * @param {string} siteId
	 */
	fetchSite: (siteId: string) => void
}

interface ReduxProps {
	address: Option<Site>
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Brand logo file.
	 */
	file: Option<File>
	/**
	 * Should remove file on update indicator
	 */
	shouldRemoveFileOnUpdate: boolean
}

type Props = IComponentProps & IDispatchProps & ReduxProps

class EditBrandForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false, file: none, shouldRemoveFileOnUpdate: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		if (this.props.address.isEmpty) {
			this.props.brand.siteId.map(this.props.fetchSite)
		}
	}

	render() {
		return (
			<Loading isLoading={this.props.brand.siteId.isDefined && this.props.address.isEmpty}>
				<EditBrandFormView onSubmit={this.onSubmit}
								   onCancel={this.props.onCancel}
								   isSubmitting={this.state.isSubmitting}
								   brand={this.props.brand}
								   address={this.props.address}
								   onAddFile={(file: File) => this.setState(
									   {file: option(file), shouldRemoveFileOnUpdate: false})}
								   onRemoveFile={() => this.setState({file: none, shouldRemoveFileOnUpdate: true})}/>
			</Loading>
		);
	}

	onSubmit(data: Brand, address: Option<Address>) {
		this.setState({isSubmitting: true}, () => {
			this.props.updateBrand(
				this.props.brand.id,
				data,
				this.state.file,
				address,
				this.state.shouldRemoveFileOnUpdate,
				() => {
					this.setState({isSubmitting: false}, () => {
						Toast.success("Brand updated", "Brand update");
						this.props.onSuccess();
					});
				},
				(error: any) => {
					let err: string;
					if (error && error.response && error.response.status == 409)
						err = `Brand with name '${data.name}' exists`;
					else
						err = "Brand update failed";
					this.setState({isSubmitting: false}, () => Toast.error(err, "Brand update"));
				}
			);
		});
	}
}

function mapStateToProps(state: RootState, props: IComponentProps) {
	return {
		address: option(state.site.sitesMap[props.brand.siteId.orNull])
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateBrand: (brandId: string,
			brand: Brand,
			file: Option<File>,
			address: Option<Address>,
			shouldRemoveLogo: boolean,
			onSuccess: OnSuccess,
			onFailure: OnFailure) =>
			dispatch(updateBrand(brandId, brand, file, address, shouldRemoveLogo, onSuccess, onFailure)),
		fetchSite: (siteId: string) => dispatch(fetchSite(siteId, () => {}, err => notifyBugsnagAndShowToast(err, "Fetch Site")))
	};
}

export default connect<ReduxProps, IDispatchProps, IComponentProps>(mapStateToProps, mapDispatchToProps)(EditBrandForm);